import axios from "axios";
import api from "../../../utils/api";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { RootState } from "../../rootReducer";
import { Document } from "../../../@types/document";
import axiosInstance from "../../../utils/axiosConfig";

const updateDocument = createAsyncThunk(
  "documentUpdate/updateDocument",
  async (params, { getState, rejectWithValue }) => {
    try {
      const state = getState() as RootState;
      const { id } = state.documentShow.document;

      const { title, category, archive } = state.documentUpdate.document;

      if (archive) {
        const { data } = await axiosInstance.post(`${api.baseURL}document/replace-archive`, {
          archiveId: archive.id,
          documentId: id,
          userId: state.userAuthentication.user?.id,
        });
        return data as Document;
      } else {
        const { data } = await axiosInstance.patch(`${api.baseURL}document/${id}`, {
          title,
          category: category?.id,
        });
        return data as Document;
      }
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export default updateDocument;
